import {Component, DestroyRef, EventEmitter, OnInit, Output} from '@angular/core';
import {TagsDetailFacade} from "../../services";
import {catchError, map, mergeMap, Observable, of} from "rxjs";
import {TagDto} from "../../domain";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-tag-delete',
  templateUrl: './tag-delete.component.html',
  styleUrls: ['./tag-delete.component.scss']
})
export class TagDeleteComponent implements OnInit {
  @Output() deleted = new EventEmitter<number>()
  @Output() deleteError = new EventEmitter<string>()
  @Output() loading = new EventEmitter<boolean>()

  protected currentTag: Observable<TagDto> | undefined
  protected tokens = {
    deleteConfirmation: 'TAGS.REMOVE_TAG_CONFIRMATION',
  }

  constructor(private tagFacade: TagsDetailFacade, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    this.loading.emit(true)
    this.currentTag = this.tagFacade.findTagById(this.tagFacade.currentTag)
    this.currentTag.subscribe(() => this.loading.emit(false))
    this.tagFacade.confirmDelete$
      .pipe(takeUntilDestroyed(this.destroyRef),
        mergeMap(() => {
          return this.tagFacade.deleteTag(this.tagFacade.currentTag)
        }),
        map(() => this.tagFacade.currentTag),
        catchError(() => of())
      ).subscribe((result) => {
      if (result) this.deleted.emit(result)
      else this.deleteError.emit('TAGS.DELETE_ERROR')
    })
  }

}
